import React, { createContext, ReactChild } from 'react';
import useSpeechSynthesis from '../Hooks/useSpeechSynthesis';

export const TTSContext = createContext({});

export default function InputProvider(props: { children: ReactChild }): JSX.Element {
  const value = useSpeechSynthesis({ voice: undefined });
  return <TTSContext.Provider value={value}>{props.children}</TTSContext.Provider>;
}
